<section *ngIf="processing">
    <h2>{{processingMessage}}...</h2>
    <mat-progress-bar mode="indeterminate" color="warn" aria-label="processing...">
    </mat-progress-bar>
</section>

<section *ngIf="!processing">
    <!-- Action Buttons -->
    <div fxLayout="row wrap" class="matero-row" fxLayoutAlign="space-between start">
        <div fxFlex="50.00" fxFlex.lt-sm="100" class="matero-col" fxLayoutAlign="start">
            <h2 class="noMarginHeader"><mat-icon>note_add</mat-icon> Generate Not Eligible Letter {{voucherApplication.id}}</h2>
        </div>
        <div fxFlex="50.00" fxFlex.lt-sm="100" class="matero-col" fxLayoutAlign="end">
            <button type="submit" name="SubmitButton" (click)="onSubmitKendo()" mat-raised-button color="primary" value="Save" title="Save">Save</button>
            &nbsp;&nbsp;
            <button mat-button mat-dialog-close="Cancel" mat-raised-button color="basic" aria-label="Cancel">Cancel</button>
        </div>
    </div>
    <hr />
</section>

<mat-dialog-content id="voucherLetterPdf">
    <div class="print-outer" >
        <div class="print-inner">
          <kendo-pdf-export #pdf paperSize="letter" paperSize="A4" margin="2cm" [scale]="0.4" forcePageBreak=".page-break">
            <ng-container [ngTemplateOutlet]="kendoTemplate"
                          [ngTemplateOutletContext]="{export: true}">
                        </ng-container>
          </kendo-pdf-export>
          </div>
      </div>
      
      <ng-template #kendoTemplate let-export="export">
        <head><meta http-equiv="Content-Type" content="text/html; charset=latin-1"></head>
        
    <style>
    .english-text  {
          font-family:  'SpanishLatin',  'SpanishLatinBold'  ;
          font-size: 20pt;
      }
      kendo-pdf-export {
          font-family:  'SpanishLatin',  'SpanishLatinBold'  ;
          font-size: 20pt;
        }
    </style>
    <!-- English -->
    <section>
        <Header>
            <img src="{{environment.baseUrl}}/assets/images/OregonWell_Letterheader.png" alt="Letter Header" width="100%" >
        </Header>
        <style>
            td,
            th {
                border: 1px solid #dddddd;
                margin-left: 5.4pt;
                padding: 0in 5.4pt 0in 5.4pt
            }
        </style>

        <body class="english-text">
            <p >
                {{today | date: 'MMMM d, y':'':'' }}
            </p>
            <p style='color:green; '>{{voucherApplication?.applicantContactName}}<br>
                {{mailingAddress}}<br>
                {{mailingCity}} {{mailingState}} {{mailingZip}}</p>
            <p></p>
            <p >Dear <span style='color:green;'>{{voucherApplication?.applicantContactName}}</span></p>

            <p >Thank you for your interest in free domestic well testing for the well providing water for
                {{voucherApplication?.wellAddress}}, {{voucherApplication?.wellCity}}, {{voucherApplication?.wellState}} {{voucherApplication?.wellZip}}.
            </p>

            <p >Oregon Health Authority (OHA) and its partners are working
                to provide safe drinking water to homes served by private domestic wells in the
                Lower Umatilla Basin Ground Water Management Area (LUBGWM<span style='color:black'>A</span>). The LUBGWMA encompasses Hermiston, Boardman,
                Irrigon, Stanfield, Echo and surrounding areas in Morrow and Umatilla counties.
                Please see the map below.</p>

            <p >LUBGWMA includes about 4,500 domestic wells serving an
                estimated 12,000 household members in the area. To receive free domestic well
                testing you must reside in the LUBGWMA area. Unfortunately, your address does
                not fall within the LUBGWMA area, so we are unable to provide free domestic
                well testing.</p>

            <p >If you have questions regarding your well, please email us at
                <a href="mailto:domestic.wells@odhsoha.oregon.gov">domestic.wells@odhsoha.oregon.gov</a>.
                Additional information can also be found at <a href="https://testmywell.oregon.gov">https://testmywell.oregon.gov</a>.
            </p>

            <p >Sincerely, <br />
                Oregon Health Authority <br />
                Domestic Well Safety Program<br />
                800 NE Oregon St Ste 640, Portland OR 97232 | 541-952-9254 <br />
                https://testmywell.oregon.gov | https://pruebadepozo.oregon.gov
            </p>
            <span style="page-break-before: always;"></span>
            <span style="page-break-before: always;" class="page-break"></span>
            <img src="{{environment.baseUrl}}/assets/images/LUBGWAMA-Boundary.jpg" alt="Area" width="100%" height="auto">
        </body>
    </section>

    <br /><br />

    <!-- Spanish -->
    <section>
        <span style="page-break-before: always;"></span>        
        <span style="page-break-before: always;" class="page-break"></span>
        <Header>
            <img src="{{environment.baseUrl}}/assets/images/OregonWell_Letterheader.png" alt="Letter Header" width="100%">
        </Header>
        <style>
            td,
            th {
                border: 1px solid #dddddd;
                margin-left: 5.4pt;
                padding: 0in 5.4pt 0in 5.4pt
            }
        </style>

        <body class="spanish-text">
            <p >
                {{today | date: 'd MMMM, y':'':'es' }}
            </p>
            <p >Estimado/Estimada, <span style='color:green; '>{{voucherApplication?.applicantContactName}}</span></p>


            <p ><span lang=es-419>Gracias por su interés en las pruebas de pozos domésticos gratuitas para el pozo ubicado en
                    {{voucherApplication?.wellAddress}}, {{voucherApplication?.wellCity}}, {{voucherApplication?.wellState}} {{voucherApplication?.wellZip}}.</span>
            </p>

            <p ><span lang=es-419>La Autoridad de Salud de Oregón (OHA, por
                    sus siglas en inglés) y sus socios están trabajando para proporcionar agua
                    potable segura a los hogares abastecidos por pozos domésticos privados en el
                    Área de Administración de Agua Subterránea de la Cuenca del Bajo Umatilla
                    (LUBGWMA, por sus siglas en inglés). La LUBGWMA abarca Hermiston, Boardman,
                    Irrigon, Stanfield, Echo y las áreas circundantes en los condados de Morrow y
                    Umatilla. Por favor, vea el mapa a continuación.</span></p>

            <p ><span lang=es-419>LUBGWMA incluye alrededor de 4500 pozos domésticos
                    que atienden a aproximadamente 12 000 miembros de hogares en el área. Para
                    recibir pruebas de pozos domésticos gratuitos, debe residir en el área de
                    LUBGWMA. Desafortunadamente, su dirección no se encuentra dentro del área de
                    LUBGWMA, por lo que no podemos proporcionar pruebas de pozos domésticos
                    gratuitos.</span></p>

            <p ><span lang=es-419>Si tiene preguntas sobre su pozo, envíenos
                    un correo electrónico a <a href="mailto:domestic.wells@odhsoha.oregon.gov">domestic.wells@odhsoha.oregon.gov</a>. También se puede
                    encontrar información adicional en <a href="https://testmywell.oregon.gov">https://testmywell.oregon.gov</a>.</span></p>

            <p >Atentamente,<br />
                Oregon Health Authority <br />
                Domestic Well Safety Program - Programa de Seguridad de Pozos Domésticos<br />
                800 NE Oregon St Ste 640, Portland OR 97232 | 541-952-9254 <br />
                https://testmywell.oregon.gov | https://pruebadepozo.oregon.gov
            </p>

            <span style="page-break-before: always;">

            </span>
            <span style="page-break-before: always;" class="page-break"></span>
            <img src="{{environment.baseUrl}}/assets/images/LUBGWAMA-Boundary.jpg" alt="Area" width="100%" height="auto">
        </body>
    </section>
      </ng-template>
</mat-dialog-content>